import { useEffect, useState } from "react";
import api, { fmtDateTime } from "@/api";
import { Card } from "@/components/ui/card";
import { MessageSquare, Smartphone, Bell, Mail } from "lucide-react";

const CH_ICON = { whatsapp: MessageSquare, sms: Smartphone, in_app: Bell, email: Mail };
const TYPE_LABELS = {
  new_lead: "New Lead Assigned", quotation_sent: "Quotation Sent", approval_request: "Approval Request",
  job_created: "Booking Confirmed", job_assigned: "Job Assigned", team_on_the_way: "Team On The Way",
  invoice_sent: "Invoice Sent", invoice_feedback: "Invoice + Feedback", payment_reminder: "Payment Reminder",
  recurring_reminder: "Re-booking Reminder", low_rating_alert: "Low Rating Alert", reorder_alert: "Reorder Alert",
  sla_escalation: "SLA Escalation", leave_request: "Leave Request", leave_decision: "Leave Decision",
  job_otp: "Completion OTP", geofence_alert: "Geofence Alert", incentive_report: "Incentive Report",
  job_booked: "Job Booked", job_rescheduled: "Job Rescheduled", booking_reminder: "Booking Reminder", admin_digest: "Daily Digest",
};

export default function Notifications() {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("all");
  useEffect(() => { api.get("/notifications").then((r) => setItems(r.data)); }, []);
  const filtered = filter === "all" ? items : items.filter((n) => n.channel === filter);

  return (
    <div className="space-y-5" data-testid="notifications-page">
      <div>
        <h1 className="font-heading text-2xl font-bold tracking-tight">Notification Audit Trail</h1>
        <p className="text-sm text-muted-foreground">Every WhatsApp / SMS / email the system sends — fully traceable (external delivery currently simulated)</p>
      </div>
      <div className="flex gap-2 flex-wrap">
        {["all", "whatsapp", "sms", "in_app", "email"].map((c) => (
          <button key={c} data-testid={`notif-filter-${c}`} onClick={() => setFilter(c)}
            className={`text-xs px-3 py-1.5 rounded-full border capitalize transition-colors ${filter === c ? "bg-primary text-inverse border-primary" : "bg-card hover:bg-accent"}`}>
            {c.replace("_", " ")}
          </button>
        ))}
      </div>
      <Card className="divide-y" data-testid="notifications-list">
        {filtered.map((n) => {
          const Icon = CH_ICON[n.channel] || Bell;
          return (
            <div key={n.id} data-testid={`notif-${n.id}`} className="p-4 flex gap-3 text-sm hover:bg-accent/30 transition-colors">
              <div className="w-9 h-9 rounded-full bg-primary text-primary flex items-center justify-center shrink-0"><Icon size={16} /></div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="font-semibold">{TYPE_LABELS[n.type] || n.type}</span>
                  <span className="text-[10px] uppercase tracking-widest px-1.5 py-0.5 rounded bg-muted text-muted-foreground">{n.channel}</span>
                  <span className="text-[10px] px-1.5 py-0.5 rounded bg-success-tint text-success">{n.status}</span>
                </div>
                <div className="text-muted-foreground mt-1">{n.message}</div>
                <div className="text-xs text-muted-foreground mt-1">To: {n.recipient} · {fmtDateTime(n.created_at)}</div>
              </div>
            </div>
          );
        })}
        {filtered.length === 0 && <div className="p-10 text-center text-muted-foreground">No notifications yet</div>}
      </Card>
    </div>
  );
}
